<script>
import BaseRadio from '@/components/BaseRadio.vue';
import BaseInput from '@/components/BaseInput.vue';

export default {
  name: 'RadioList',
  components: { BaseInput, BaseRadio },
  model: { prop: 'value', event: 'change' },
  props: {
    items: Array,
    withOwn: Boolean,
    value: String,
  },
  data() {
    return {
      ownVariant: ' ',
    };
  },
  computed: {
    isOwnSelected() {
      return this.ownVariant === this.value; //!!this.value && !this.items.includes(this.value);
    },
  },
  mounted() {
    if (this.isOwnSelected) {
      this.ownVariant = this.value;
    }
  },
};
</script>

<template lang="pug">
.radio-list
  .item(v-for="item in items" :key="item")
    BaseRadio(:checked="value === item" @check="$emit('change', item)")
    | {{ item }}
  .item.own(v-if="withOwn")
    BaseRadio(:checked="isOwnSelected" @check="$emit('change', ownVariant)")
    BaseInput(v-model="ownVariant" @input="$emit('change', ownVariant)" label="Свой вариант")
</template>

<style scoped lang="scss">
.radio-list {
  display: grid;
  gap: 10px;
}

.item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  line-height: 15px;
  color: #788CA1;
}
</style>
